import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { BankAccountTransactions } from "./BankAccountTransactions";

export class CreateLoadBankTransactions {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:[string], uuid:string|number, listFilters?): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids,
    }
    let args_check = {
      transaction_ids: transaction_ids,
      bank_account_id: uuid
    }
    try {
      this.frontend.loading_contabilizar_movimientos(true)

      let res_check = await this.dispatcher.dispatch('check.accounting.year.active', args_check)
      if (res_check.output['status'] == "200" && res_check.output['data'] == "ok") {
      
        let res = await this.dispatcher.dispatch('create_load_bank_transactions', args)
        if (res.output['status'] === 'error') {
          if (res.output['error_message'] === 'Saldo insuficiente') {
            this.frontend.generic_error_msg = 'Saldo insuficiente. Por favor contrate alguno de los paquetes disponibles para poder realizar esta acción.'
          } else if (res.output['error_message'] === 'Contabilizando traspaso entre cuentas') {
            this.frontend.generic_error_msg = 'Los traspasos entre cuentas se deben contabilizar en el apunte en negativo'
          }
          this.frontend.show_generic_error = true
        } else if (res.output['status'] === 'ok') {
          this.frontend.genericInformationDialogMsg = "Las transacciones se están contabilizando."
          this.frontend.showGenericInformationDialog = true
          await new BankAccountTransactions(this.q_dispatcher, this.frontend).run_filter(uuid, listFilters, this.frontend.$refs.bankSimpleFilters.option_selected, this.frontend.limit, this.frontend.offset)
        }

      }
      else {        
        if (res_check.output['status'] == "200" && res_check.output['data'] == "noActivePeriod") {
          this.frontend.generic_error_msg = "El ejercicio no está activo en la empresa en la fecha de alguno de los movimientos"
        } else {
          this.frontend.generic_error_msg = "Ha ocurrido algun error durante la comprobacion del ejercicio activo para los movimientos"
        } 
        this.frontend.show_generic_error = true    
      }
    } catch (error) {
      console.error('Error contabilizar movimientos', error)
    }
    this.frontend.loading_contabilizar_movimientos(false)
  }
}